package pl.decks.posthog.config

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlinx.serialization.Transient
import pl.decks.posthog.toDynamic

@Serializable
data class PostHogConfig(

    @SerialName("api_host")
    val apiHost: String = "https://us.i.posthog.com",
    @SerialName("capture_pageview")
    val capturePageview: Boolean = true,
    @SerialName("disable_session_recording")
    val disableSessionRecording: Boolean = false,
    @SerialName("defaults")
    val defaults: String? = null,
    @Transient
    val personProfiles: PersonProfiles = PersonProfiles.IDENTIFIED_ONLY,
    @Transient
    val persistence: Persistence = Persistence.COOKIE,
) {
    internal fun toDynamicConfig(): dynamic {
        val jsConf = this.toDynamic()
        jsConf["persistence"] = persistence.jsValue
        jsConf["person_profiles"] = personProfiles.jsValue
        return jsConf
    }
}
